// ─────────────────────────────────────────────────────────────────
// Sehat AI — useVoiceInput Custom Hook
// Speech recognition with Hindi + English support
// ─────────────────────────────────────────────────────────────────

import { useState, useRef, useCallback } from 'react';

export function useVoiceInput({ lang = 'en', onResult }) {
  const [isListening, setIsListening] = useState(false);
  const [error, setError] = useState(null);
  const recognitionRef = useRef(null);

  const start = useCallback(() => {
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SR) {
      setError('Voice input requires Chrome browser. Please use Chrome!');
      alert('Voice input requires Google Chrome. Please open this app in Chrome browser.');
      return;
    }

    setError(null);
    const recognition = new SR();
    recognition.lang = lang === 'hi' ? 'hi-IN' : 'en-IN';
    recognition.continuous = false;
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;

    recognition.onstart = () => setIsListening(true);

    recognition.onresult = (e) => {
      const transcript = e.results[0][0].transcript;
      onResult?.(transcript);
      setIsListening(false);
    };

    recognition.onerror = (e) => {
      setError(e.error);
      setIsListening(false);
    };

    recognition.onend = () => setIsListening(false);

    recognitionRef.current = recognition;
    recognition.start();
  }, [lang, onResult]);

  const stop = useCallback(() => {
    recognitionRef.current?.stop();
    setIsListening(false);
  }, []);

  return { isListening, error, start, stop };
}
